import { render } from "./ColumnOffset.vue?vue&type=template&id=1d0d9d1f&scoped=true&ts=true"
import script from "./ColumnOffset.vue?vue&type=script&lang=ts"
export * from "./ColumnOffset.vue?vue&type=script&lang=ts"

import "./ColumnOffset.vue?vue&type=style&index=0&id=1d0d9d1f&lang=scss&scoped=true"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0d9d1f"]])

export default __exports__